import { createFileRoute } from '@tanstack/react-router';
import { EmpresaListPage } from '@/features/painel-administrativo/empresa/page/list/EmpresaListPage';

export const Route = createFileRoute('/admin/_a/empresa')({
    component: EmpresaListPage,
});
